// src/components/const/Daily/DailyHeader.jsx
import React, { useState } from "react";
import TableCell from "../../common/ui/TableCell";
import ReferenceModal from "../../approval/ReferenceModal";
import PeopleCellLoader from "../../common/people/PeopleCellLoader";

export default function DailyHeader({
  projectName,
  date,
  setDate,
  dns,
  author,
  reviewers,
  weather,
  tempMin,
  tempMax,
  tempAvg,
  precipTotal,
  precipAvg,
  snowTotal,
  snowAvg,
  windAvg,
  windMax,
  setWeather,
  setTempMin,
  setTempMax,
  setTempAvg,
  setPrecipTotal,
  setPrecipAvg,
  setSnowTotal,
  setSnowAvg,
  setWindAvg,
  setWindMax,
  setReviewers
}) {


  return (
    <div className="space-y-6">
      {/* ==========================
          ① 기본 정보
      =========================== */}
      <div className="">
        <h3 className="text-body-bold mb-2">기본 정보</h3>

        <table className="w-full text-sm border">
          <tbody>
            {/* 현장명 + 일자 */}
            <tr>
              <TableCell label="현장명" value={projectName || "-"} />

              <TableCell
                label="일자"
                editing
                input={
                  <input
                    type="date"
                    value={date}
                    onChange={(e) => setDate?.(e.target.value)}
                    className="w-full border rounded px-2 py-1"
                  />
                }
              />
            </tr>

            {/* 작성자 + 확인자 */}
            <tr>
              <TableCell label="작성자" value={author ?? "-"} />

              <TableCell
                colSpan={3}
                label="확인자"
                editing
                input={
                  <PeopleCellLoader
                    dns={dns}
                    value={reviewers}
                    onChange={(list) => setReviewers(list)}
                  />
                }
              />
            </tr>
          </tbody>
        </table>
      </div>

      {/* ==========================
          ② 기상 정보
      =========================== */}
      <div className="">
        <h3 className="text-body-bold mb-2">기상 정보</h3>

        <table className="w-full text-sm border">
          <tbody>
            {/* 1행: 날씨 + 최저 기온 */}
            <tr>
              <TableCell
                label="날씨"
                editing
                input={
                  <input
                    type="text"
                    className="w-full border rounded px-2 py-1"
                    value={weather}
                    onChange={(e) => setWeather?.(e.target.value)}
                    placeholder="예: 맑음"
                  />
                }
              />

              <TableCell
                label="최저 기온 (°C)"
                editing
                input={
                  <input
                    type="number"
                    className="w-full border rounded px-2 py-1 text-right"
                    value={tempMin}
                    onChange={(e) =>
                      setTempMin?.(
                        e.target.value === "" ? "" : parseFloat(e.target.value)
                      )
                    }
                    onWheel={(e) => e.currentTarget.blur()}
                    onBlur={(e) => {
                      if (e.target.value === "" || e.target.value === null) {
                        alert(
                          "최저 기온을 입력해주세요. 해당되지 않는다면 0으로 표기해주세요."
                        );
                        setTempMin?.(0);
                      }
                    }}
                  />
                }
              />
            </tr>

            {/* 2행: 최고 기온 + 평균 기온 */}
            <tr>
              <TableCell
                label="최고 기온 (°C)"
                editing
                input={
                  <input
                    type="number"
                    className="w-full border rounded px-2 py-1 text-right"
                    value={tempMax}
                    onChange={(e) =>
                      setTempMax?.(
                        e.target.value === "" ? "" : parseFloat(e.target.value)
                      )
                    }
                    onWheel={(e) => e.currentTarget.blur()}
                    onBlur={(e) => {
                      if (e.target.value === "" || e.target.value === null) {
                        alert(
                          "최고 기온을 입력해주세요. 해당되지 않는다면 0으로 표기해주세요."
                        );
                        setTempMax?.(0);
                      }
                    }}
                  />
                }
              />

              <TableCell
                label="평균 기온 (°C)"
                editing
                input={
                  <input
                    type="number"
                    className="w-full border rounded px-2 py-1 text-right"
                    value={tempAvg}
                    onChange={(e) =>
                      setTempAvg?.(
                        e.target.value === "" ? "" : parseFloat(e.target.value)
                      )
                    }
                    onWheel={(e) => e.currentTarget.blur()}
                    onBlur={(e) => {
                      if (e.target.value === "" || e.target.value === null) {
                        alert(
                          "평균 기온을 입력해주세요. 해당되지 않는다면 0으로 표기해주세요."
                        );
                        setTempAvg?.(0);
                      }
                    }}
                  />
                }
              />
            </tr>

            {/* 3행: 강수량 (누계 / 평균) */}
            <tr>
              <TableCell
                label="강수량 누계 (mm)"
                editing
                input={
                  <input
                    type="number"
                    className="w-full border rounded px-2 py-1 text-right"
                    value={precipTotal}
                    onChange={(e) =>
                      setPrecipTotal?.(
                        e.target.value === "" ? "" : parseFloat(e.target.value)
                      )
                    }
                    onWheel={(e) => e.currentTarget.blur()}
                    onBlur={(e) => {
                      if (e.target.value === "" || e.target.value === null) {
                        alert(
                          "강수량 누계를 입력해주세요. 해당되지 않는다면 0으로 표기해주세요."
                        );
                        setPrecipTotal?.(0);
                      }
                    }}
                  />
                }
              />

              <TableCell
                label="강수량 평균 (mm)"
                editing
                input={
                  <input
                    type="number"
                    className="w-full border rounded px-2 py-1 text-right"
                    value={precipAvg}
                    onChange={(e) =>
                      setPrecipAvg?.(
                        e.target.value === "" ? "" : parseFloat(e.target.value)
                      )
                    }
                    onWheel={(e) => e.currentTarget.blur()}
                    onBlur={(e) => {
                      if (e.target.value === "" || e.target.value === null) {
                        alert(
                          "강수량 평균을 입력해주세요. 해당되지 않는다면 0으로 표기해주세요."
                        );
                        setPrecipAvg?.(0);
                      }
                    }}
                  />
                }
              />
            </tr>

            {/* 4행: 적설량 (누계 / 평균) */}
            <tr>
              <TableCell
                label="적설량 누계 (cm)"
                editing
                input={
                  <input
                    type="number"
                    className="w-full border rounded px-2 py-1 text-right"
                    value={snowTotal}
                    onChange={(e) =>
                      setSnowTotal?.(
                        e.target.value === "" ? "" : parseFloat(e.target.value)
                      )
                    }
                    onWheel={(e) => e.currentTarget.blur()}
                    onBlur={(e) => {
                      if (e.target.value === "" || e.target.value === null) {
                        alert(
                          "적설량 누계를 입력해주세요. 해당되지 않는다면 0으로 표기해주세요."
                        );
                        setSnowTotal?.(0);
                      }
                    }}
                  />
                }
              />
              <TableCell
                label="적설량 평균 (cm)"
                editing
                input={
                  <input
                    type="number"
                    className="w-full border rounded px-2 py-1 text-right"
                    value={snowAvg}
                    onChange={(e) =>
                      setSnowAvg?.(
                        e.target.value === "" ? "" : parseFloat(e.target.value)
                      )
                    }
                    onWheel={(e) => e.currentTarget.blur()}
                    onBlur={(e) => {
                      if (e.target.value === "" || e.target.value === null) {
                        alert(
                          "적설량 평균을 입력해주세요. 해당되지 않는다면 0으로 표기해주세요."
                        );
                        setSnowAvg?.(0);
                      }
                    }}
                  />
                }
              />
            </tr>

            {/* 5행: 풍속 (평균 / 최대) */}
            <tr>
              <TableCell
                label="평균 풍속 (m/s)"
                editing
                input={
                  <input
                    type="number"
                    className="w-full border rounded px-2 py-1 text-right"
                    value={windAvg}
                    onChange={(e) =>
                      setWindAvg?.(
                        e.target.value === "" ? "" : parseFloat(e.target.value)
                      )
                    }
                    onWheel={(e) => e.currentTarget.blur()}
                    onBlur={(e) => {
                      if (e.target.value === "" || e.target.value === null) {
                        alert(
                          "평균 풍속을 입력해주세요. 해당되지 않는다면 0으로 표기해주세요."
                        );
                        setWindAvg?.(0);
                      }
                    }}
                  />
                }
              />

              <TableCell
                label="최대 풍속 (m/s)"
                editing
                input={
                  <input
                    type="number"
                    className="w-full border rounded px-2 py-1 text-right"
                    value={windMax}
                    onChange={(e) =>
                      setWindMax?.(
                        e.target.value === "" ? "" : parseFloat(e.target.value)
                      )
                    }
                    onWheel={(e) => e.currentTarget.blur()}
                    onBlur={(e) => {
                      if (e.target.value === "" || e.target.value === null) {
                        alert(
                          "최대 풍속을 입력해주세요. 해당되지 않는다면 0으로 표기해주세요."
                        );
                        setWindMax?.(0);
                      }
                    }}
                  />
                }
              />
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
